import { BAR_STAGES, STAGE_NAMES, tierClass } from "../../../../lib/giftingRules";
import type { GfStage } from "../../../../types/gifting";
import type { ListRow } from "./listModel";
import type { PipelineCtx } from "./model";
import { rowView } from "./rowView";

/**
 * カンバン（補助）: 段階 1〜7 の 7 列・横スクロール。見出しクリックで幅44pxの縦書きに折りたたむ（state のみ）。
 * カード左端 inset 3px にティア色。待ちは opacity .55。
 */
export function KanbanBoard({
  rows,
  ctx,
  collapsed,
  openId,
  onToggleCol,
  onOpen,
}: {
  rows: ListRow[];
  ctx: PipelineCtx;
  collapsed: Record<number, boolean>;
  openId: string | null;
  onToggleCol: (stage: number) => void;
  onOpen: (id: string) => void;
}) {
  return (
    <div className="gf-kb2">
      {BAR_STAGES.map((s: GfStage) => {
        const cards = rows.filter((r) => r.e.stage === s);
        const need = cards.filter((r) => r.action.tier < 5).length;
        const open = !collapsed[s];
        return (
          <section key={s} className={`gf-kb2-col${open ? "" : " is-collapsed"}`} aria-label={STAGE_NAMES[s]}>
            <button type="button" className="gf-kb2-head" aria-expanded={open} onClick={() => onToggleCol(s)}>
              <span className="gf-kb2-title">{STAGE_NAMES[s]}</span>
              <span className="gf-mono gf-kb2-count">{cards.length}</span>
              {need > 0 && <span className="gf-kb2-need">要対応 {need}</span>}
              <span className="gf-kb2-caret">{open ? "‹" : "›"}</span>
            </button>
            {open && (
              <div className="gf-kb2-cards">
                {cards.length === 0 && <div className="gf-kb2-empty">該当なし</div>}
                {cards.map((r) => {
                  const v = rowView(r, ctx);
                  const dl = r.e.stage === 5 && r.e.post_count === 0 ? v.deadline : null;
                  return (
                    <button
                      type="button"
                      key={r.e.id}
                      className={`gf-kb2-card ${tierClass(r.action.tier)} is-t${r.action.tier}${r.action.tier === 5 ? " is-wait" : ""}${
                        openId === r.e.id ? " is-open" : ""
                      }`}
                      onClick={() => onOpen(r.e.id)}
                    >
                      <span className="gf-kb2-top">
                        <span className="gf-kb2-name">{r.info.creatorName}</span>
                        <span className="gf-kb2-act">{r.action.tier === 5 ? "待ち" : r.action.label}</span>
                      </span>
                      <span className="gf-kb2-camp">{r.info.campaignName}</span>
                      <span className="gf-kb2-foot">
                        <span className={`gf-kb2-c1${v.contact.tone ? ` is-${v.contact.tone}` : ""}`}>{v.contact.c1}</span>
                        {dl && dl.text !== "—" && <span className={`gf-kb2-dl is-${dl.tone}`}>{dl.text}</span>}
                      </span>
                    </button>
                  );
                })}
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
